import {CP, IP} from "../setting/initParam";
import {
    centeredLine, createDefaultMaterial, CutPlane, InitialStruct, JoinGashAndAngleParams,
    JoinPlane,
    JoinType,
    JoinVariant,
    matBeam, ParamsGetSimpleBoard, ParamsJsonCuts, RenderElement,
    RenderStruct, simpleSize, Vec2, Vec3
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";
import {locale} from "../setting/locale";


export async function getF1(s:InitialStruct, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {

    const joinEndAndAngleParams:JoinGashAndAngleParams = {
        gash: IP.gash.simple,
        width: IP.elementData.pillar.sizeBoard.h / 2,
        angle: s.a,
        indent: IP.elementData.harness.sizeBoard.h,
        joinType: JoinType.End,
        joinPlane: JoinPlane.Bottom,
        variant: JoinVariant.GashAndAngle
    }
    const joinStartGashAndAngleParams:JoinGashAndAngleParams = {
        gash: IP.gash.simple,
        width: IP.elementData.pillar.sizeBoard.h / 2,
        angle: s.a,
        indent: IP.elementData.harness.sizeBoard.h,
        joinType: JoinType.Start,
        joinPlane: JoinPlane.Bottom,
        variant: JoinVariant.GashAndAngle
    }

    const pointF3:Vec2 = [sBoard.l / 2, 0]
    const lineCut:Vec2[] = []
    lineCut.push(pointF3)
    if (s.w > 6) {
        const offsetCutF5 =
            + IP.elementData.f2.sizeBoard.w / 2
            + IP.elementData.f5.sizeBoard.w / 2
            + CP.maps.f4.point[0]
        lineCut.push([sBoard.l / 2 - offsetCutF5, 0])
        lineCut.push([sBoard.l / 2 + offsetCutF5, 0])
        if (s.w > 7) {
            const offsetCutF7 =
                + IP.elementData.f2.sizeBoard.w / 2
                + IP.elementData.f7.sizeBoard.w / 2
                + CP.maps.f6.point[0]
            lineCut.push([sBoard.l / 2 - offsetCutF7, 0])
            lineCut.push([sBoard.l / 2 + offsetCutF7, 0])
        }
    }

    const cut:ParamsJsonCuts = {
        gash: IP.gash.simple,
        line: lineCut,
        plane: CutPlane.Bottom,
        width: IP.elementData.f2.sizeBoard.w
    }

    const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l: sBoard.l},
        cuts: [cut,],
        joinStart: joinStartGashAndAngleParams,
        joinEnd: joinEndAndAngleParams,
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    const specIds: string[] = []
    rs.material.push(createDefaultMaterial())
    const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
    rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
    const numUvs = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoard.mesh.indices)
    const numIndices = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
    const numVertices = rs.vertices.length - 1
    const nameGroup = IP.elementData.f1.groupName || 'trust'
    const nameElement = IP.elementData.f1.name || 'f1'
    rs.group = nameGroup
    const numGroups = rs.group.length
    const meta = resultGetSimpleBoard.meta

    const line = CP.maps.f1.lineCut

    const realSeg = centeredLine(CP.maps.f1.lineCut, s.l)

    const specID = nameElement
    for (let i = 0; i < realSeg.length; i++) {
        const x = realSeg[i][0]
        const pos:Vec3 = [x, s.h - IP.gash.simple + sBoard.h / 2, 0]

        const board: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: pos,
            rotation: [Math.PI / 2,0,0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
            specId: specID,
        }
        rs.elements.push(board)
    }
    spec.push({
        w: resultGetSimpleBoard.meta.w,
        h: resultGetSimpleBoard.meta.h,
        l: resultGetSimpleBoard.meta.l,
        name: nameElement,
        group: nameGroup,
        count: (realSeg.length),
        materialId: IP.elementData.f1.materialId,
        specId: specID,
    })
    specIds.push(specID)
    rs.specIds = specIds

    return {rs: rs, spec: spec}
}
